import * as React from 'react';
import { isPropertySignature } from 'typescript';

import style from './ButtonNext.module.css';

type Props = {
    arrowMode?: boolean,
    children?: any,
    onClick: Function
}

const ButtonNext = (props: Props) => {
    const [backgroundColor, setBackgroundColor] = React.useState('#EC0000');

    const onMouseEnter = () => {
        setBackgroundColor('#B90000');
    }
    const onMouseLeave = () => {
        setBackgroundColor('#EC0000');
    }

    const arrow = props.arrowMode ? (<div style={{borderLeftColor: backgroundColor}} onClick={(e)=>{props.onClick(e)}} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className={style.arrowRight}></div>) : '';
    const buttonMode = props.arrowMode ? style.arrowMode : style.squareMode;
    return (
        <React.Fragment>
            <div onClick={(e)=>{props.onClick(e)}} style={{backgroundColor: backgroundColor}} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className={`${style.buttonBase} ${buttonMode}`}>{props.children}</div>
            {arrow}
        </React.Fragment>
    )
}

export default ButtonNext;